import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_get_purchase_ordersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { filters?: $types.FootPrintApiManager.input_get_purchase_order, paging?: { top?: number, skip?: number } }): Promise<{ orders?: $types.FootPrintApiManager.public_order[] }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/get_purchase_orders`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

